import React, { useState, useRef } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import Modal from '../../../../commonComponents/modal/Modal';
import ModalHeader from '../../../../commonComponents/modal/ModalHeader';
import List from '../../../../commonComponents/lists/List';
import Comment from './Comment';

function CommentsModal({ t, eventId, onClose, onAddComment }) {
  const [comment, setComment] = useState('');
  const tableEl = useRef(null);

  const columns = [
    {
      field: 'name',
      textAlign: 'center',
      title: '',
      template: item => renderToStaticMarkup(<Comment comment={item} />),
    },
  ];

  const handleAdd = () => {
    setComment('');
    onAddComment(eventId, comment);
    if (tableEl.current) {
      tableEl.current.forceReload();
    }
  };

  const handleKeyUp = ({ key }) => {
    if (key === 'Enter') {
      handleAdd();
    }
  };

  return (
    <Modal onClose={onClose}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <ModalHeader
            title={t('challengeDetails_comments')}
            onClose={onClose}
          />
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row" style={{ marginBottom: '4rem' }}>
                <div className="col-12">
                  <div className="form-group m-form__group">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t('challengeDetails_comment_placeholder')}
                        value={comment}
                        onChange={({ target }) => setComment(target.value)}
                        onKeyUp={handleKeyUp}
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-dynamic"
                          onClick={handleAdd}
                          disabled={!comment}
                        >
                          <i className="flaticon-paper-plane" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <List
                    ref={tableEl}
                    id="commentsList"
                    dataSourceURL={`/challenges/event/${eventId}/comment/list`}
                    columns={columns}
                    query={{}}
                    defaultPageSize={5}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              {t('close')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

CommentsModal.propTypes = {
  t: PropTypes.func.isRequired,
  eventId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onAddComment: PropTypes.func.isRequired,
};

export default translate(CommentsModal);
